import Login from '@views/authentication/sign-in';
import SignUp from '@views/authentication/sign-up';
import SignOut from '@views/authentication/sign-out';
import ForgotPassword from '@views/authentication/forgot-password';
import DashboardComponent from '@views/singletons/dashboard';
import SupportComponent from '@views/singletons/support';
import Onboarding from '@views/singletons/onboarding';
import ChecklistView from '@views/singletons/checklist';
import DownloadApp from '@views/singletons/DownloadApp';
import PopInsights from '@views/singletons/possibilityOfPassingInsights';

export default [
  {
    path: '/',
    name: 'home',
    component: DashboardComponent,
    meta: {
      mastery: true,
      resourceOptional: true,
    },
  },
  {
    path: '/sign-in',
    name: 'signIn',
    component: Login,
    meta: {
      mastery: true,
      public: true,
      sidebar: 'hide',
    },
  },
  {
    path: '/sign-up',
    name: 'signUp',
    component: SignUp,
    meta: {
      mastery: true,
      public: true,
      sidebar: 'hide',
    },
  },
  {
    path: '/sign-out',
    name: 'signOut',
    component: SignOut,
    meta: {
      sidebar: 'hide',
    },
  },
  {
    path: '/forgot-password',
    name: 'forgotPassword',
    component: ForgotPassword,
    meta: {
      mastery: true,
      public: true,
      sidebar: 'hide',
    },
  },
  {
    path: '/support',
    name: 'support',
    component: SupportComponent,
    meta: {
      public: true,
      secondaryRoute: true,
      sidebar: 'hideUnlessAuthenticated',
    },
  },
  {
    path: '/eula',
    name: 'eula',
    component: () => import('@views/singletons/eula'),
    meta: {
      public: true,
      secondaryRoute: true,
      sidebar: 'hideUnlessAuthenticated',
    },
  },
  {
    path: '/onboarding',
    name: 'onboarding',
    component: Onboarding,
    meta: {
      resourceOptional: true,
      sidebar: 'hide',
    },
  },
  {
    path: '/checklists/:checklistId',
    name: 'checklist#show',
    component: ChecklistView,
    meta: {
      header: true,
      resourceOptional: true,
    },
  },
  {
    path: '/download-app',
    name: 'downloadApp',
    component: DownloadApp,
  },
  {
    path: '/pop-insights',
    name: 'popInsights#show',
    component: PopInsights,
    meta: {
      mastery: true,
      header: true,
      resourceOptional: true,
    },
  },
];
